const defaultState = {
    MapInfo: null,
    Session: null,
    UserInfo: null,
    Pages: null,
    login: false
} // 默认数据

export default (state = defaultState, action) => {
    if (action.type === 'saveUserInfo') {
        window.localStorage.setItem('commercialUserData', JSON.stringify(action.data));
        return {
            ...action.data,
            login: true,
        }
    }
    if (action.type === 'clearUserInfo') {
        window.localStorage.removeItem('commercialUserData');
        return JSON.parse(JSON.stringify(defaultState))
    }
    return state
}
